export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "period_count_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouveaux contrats"])},
        "period_count_label_leads": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulaires complétés"])},
        "period_count_label_gross_sales": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ventes brutes"])},
        "period_count_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre de nouveaux contrats vendus durant la période sélectionnée."])},
        "period_count_tooltip_leads": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre de formulaires de devoir de conseil complétés durant la période sélectionnée."])},
        "period_count_tooltip_gross_sales": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre total de ventes brutes réalisées durant la période sélectionnée."])}
      },
      "en": {
        "period_count_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New contracts"])},
        "period_count_label_leads": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Completed forms"])},
        "period_count_label_gross_sales": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gross sales"])},
        "period_count_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Number of new contracts sold during the selected period."])},
        "period_count_tooltip_leads": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Number of advisory duty forms completed during the selected period."])},
        "period_count_tooltip_gross_sales": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total number of gross sales made during the selected period."])}
      }
    }
  })
}
